import { StrictMode } from 'react';

import { ErrorBoundary } from '@game/ui';
import ReactDOMClient from 'react-dom/client';

import { initializeIconRegistry } from '@components/Icon/iconRegistry';
import TestWrapper from '@components/TestWrapper/TestWrapper';

import App from './App';
import { AuthProvider } from './context/Auth/AuthProvider';
import { SocketProvider } from './context/Socket/SocketProvider';

import './PluralizeRules';
import './index.css';

initializeIconRegistry();

const container = document.querySelector('#root');

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = ReactDOMClient.createRoot(container!);

root.render(
  <StrictMode>
    <ErrorBoundary>
      <AuthProvider>
        <SocketProvider>
          <TestWrapper>
            <App />
          </TestWrapper>
        </SocketProvider>
      </AuthProvider>
    </ErrorBoundary>
  </StrictMode>,
);
